import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AddProductToOrderForm";
import {LIST_SELLABLE_PRODUCTS} from "../../queries/inventory";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAddProductToShippingOrder} from "../../actions/ShippingApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence, validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";
import {sellableGroups} from "../../lib/StockHelper";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "productSku");
  errors = validateGreaterThan(errors, values, "quantity", 0);
  return errors.toJS();
}

class AddProductToOrderFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("orderId", this.props.orderId);
    return this.props.addProductToShippingOrder(updatedValues.toJS())
      .then((response) => {
        if (response.data.addProductToShippingOrder.errors.length <= 0) {
          this.props.cancelAddProductToShippingOrder();
        } else {
          let errors = createValidationErrors(response.data.addProductToShippingOrder.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelAddProductToShippingOrder();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    // Convert "sku" to "productSku"
    // Convert "title" to "productTitle"
    let items = fromJS(data.sellableProducts).map(x => {
      return Map({
        productSku: x.get("sku"),
        productTitle: x.get("title"),
        type: x.get("type")
      });
    })

    return (
      <Form
        products={items}
        groups={sellableGroups()}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ADD_PRODUCT_TO_SHIPPING_ORDER = gql`
  mutation addProductToShippingOrder($data: AddProductToShippingOrderInput!) {
    addProductToShippingOrder(input: $data) {
      errors { key message }
    }
  }
`;

const withProductQuery = compose(
  graphql(LIST_SELLABLE_PRODUCTS, {
    options: (props) => ({
      fetchPolicy: "network-only"
    })
  }),
  graphql(ADD_PRODUCT_TO_SHIPPING_ORDER, {
    props: ({ mutate }) => ({
      addProductToShippingOrder: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const AddProductToOrderFormContainerWithData = withProductQuery(AddProductToOrderFormContainer);

export default connect(null, {cancelAddProductToShippingOrder})(AddProductToOrderFormContainerWithData);